import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { environment } from 'src/environments/environment';
declare let ga: Function;
@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PrivacyPolicyComponent implements OnInit {
  performerInfoSubscr:Subscription;
  routerevents: any;
  clientDetails : any;
  assets_url = environment.assets_url;
  settingsData: any = {};
  settingsDataSubscription: Subscription;
  constructor(private storageService: StorageService, private commanSubscribeService: CommanSubscribeService,public router: Router,private activeRoute:ActivatedRoute) {
   }

  channelName=''
  channel=''
  performer_details:any={};
  showimg:boolean=false;
  ngOnInit() {
    this.clientDetails = environment.clientDetails;
    let perfomerInfoData = this.commanSubscribeService.perfomerInfoData;
    this.performer_details = perfomerInfoData.data?perfomerInfoData.data.Data[0].performer_details:''; 
    if(perfomerInfoData && Object.keys(perfomerInfoData).length != 0) {
      perfomerInfoData = this.commanSubscribeService.perfomerInfoData;
    }
    this.channelName= perfomerInfoData.data ? perfomerInfoData.data.Data[0].channel_display_name : '';
    this.settingsData = this.channelName ? this.commanSubscribeService.icWebpageSettingsData : {};
    this.settingsDataSubscription = this.commanSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      if (this.channelName) {
        this.settingsData = response;
      }
    });
    this.channel=perfomerInfoData.data?perfomerInfoData.data.Data[0].channel_name:'';      
    this.performerInfoSubscr = this.commanSubscribeService.getPerfomerInfo().subscribe(response => {
            perfomerInfoData =response;
            this.performer_details = perfomerInfoData.data.Data[0].performer_details; 
            this.channelName= perfomerInfoData.data.Data[0].channel_display_name
            this.settingsData = this.channelName ? this.commanSubscribeService.icWebpageSettingsData : {};
            this.channel=perfomerInfoData.data.Data[0].channel_name;
            console.log(perfomerInfoData)
          })
          console.log(perfomerInfoData)
          if(this.activeRoute.snapshot.params.channelName){
            try { ga('set', 'page', this.router.url);ga('send', 'pageview'); } catch (e) { }
        }
        }
        gotolink(data){
          if(this.router.url.toLowerCase().includes(this.channel.toLowerCase()) && this.channel != '' )
          this.router.navigate(['/' + this.channel + '/'+data])
          else
          this.router.navigate([ '/'+data])
        }
      
}
